import { projectTypeName } from "../../../common/constants";
import { centsToDollarsDisplay } from "../../displayFormatters";
import { CsvColumn } from "../reportCsvExport";
import { flattenStatusBuckets, StatusBucket, WithStatus } from "../statusBucketsExport";
import { ProposalReportData, ProposalsSummary } from "./proposalsReportApi";
import { addApprovedToSent, getFilteredProposalsData } from "./proposalsReportModel";

export const proposalStatusBuckets: StatusBucket[] = [
  { key: 'unsent', label: 'Draft' },
  { key: 'sent', label: 'Sent' },
  { key: 'pending', label: 'Pending' },
  { key: 'approved', label: 'Approved' },
  { key: 'lost', label: 'Lost' },
]

// Approved, then Lost, are the most advanced buckets, and they price a job by what was
// actually approved, so the exported row takes its figures from the job's last bucket.
// Built after addApprovedToSent, like the Sent tab, so a job that is approved but was never sent is labelled "Sent, Approved" there too.
export const getProposalExportRows = (
  proposals: ProposalsSummary,
  salesPersonIds: string[],
  projectTypeIds: number[],
  divisionIds: string[]
): WithStatus<ProposalReportData>[] =>
  flattenStatusBuckets(getFilteredProposalsData(addApprovedToSent(proposals), salesPersonIds, projectTypeIds, divisionIds), proposalStatusBuckets, 'last')

export const getProposalDivisionNames = (divisions: string): string =>
  divisions ? [...new Set(divisions.split(';').map(d => d.trim()))].join(', ') : ''

export const noProposals: ProposalsSummary = { unsent: [], sent: [], approved: [], lost: [], pending: [] }

export const proposalExportColumns: CsvColumn<WithStatus<ProposalReportData>>[] = [
  { title: 'Name', dataIndex: 'jobName' },
  { title: 'Customer', dataIndex: 'displayName' },
  { title: 'Property', render: (_, record) => `${record.address1}, ${record.city}, ${record.state}, ${record.zip}` },
  { title: 'Final Price', dataIndex: 'price', render: (_, record) => centsToDollarsDisplay(record.price), exportCents: record => record.price },
  { title: 'Job Type', dataIndex: 'jobType', render: (_, record) => projectTypeName(record.jobType) },
  { title: 'Sales Person', dataIndex: 'salesPersonName' },
  { title: 'Division', dataIndex: 'divisions', render: (_, record) => getProposalDivisionNames(record.divisions) },
  { title: 'Status', dataIndex: 'status' },
]
